import styled, { css } from 'styled-components';
import { PropsWithChildren } from 'react';
import { device } from '@styles/mediaQuery';

type ContactProps = PropsWithChildren & {
  title: string;
  description: string;
};

function Contact({ title, description, children }: ContactProps) {
  return (
    <Wrapper>
      <StyledTitle>{title}</StyledTitle>
      <StyledDescription>{description}</StyledDescription>
      <ChildrenWrapper>{children}</ChildrenWrapper>
    </Wrapper>
  );
}

const StyledTitle = styled.span`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 13px;
  color: ${({ theme }) => theme.colors.textPrimary};

  ${device.tablet(css`
    font-size: 24px;
  `)}
`;

const StyledDescription = styled.span`
  font-size: 16px;
  margin-bottom: 15px;
  color: ${({ theme }) => theme.colors.textSecondary};

  ${device.tablet(css`
    font-size: 18px;
  `)}
`;

const ChildrenWrapper = styled.div`
  margin-bottom: 32px;
`;

const Wrapper = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${device.mobileL(css`
    align-items: center;
  `)}

  ${device.laptopL(css`
    align-items: flex-start;
  `)}
`;

export default Contact;
